export default function ConfirmDeleteModal({
  isOpen,
  onClose,
  onConfirm,
  fileName,
  title = "Delete File",
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg w-full max-w-md">
        {/* Header (Title) */}
        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-4 dark:text-white">
            {title}
          </h2>
        </div>

        {/* Body */}
        <div>
          <p className="text-gray-600 mb-6 dark:text-gray-300">
            Are you sure you want to delete{" "}
            <span className="font-medium text-red-600">{fileName}</span>?
          </p>
        </div>

        {/* Footer (Buttons) */}
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 transition"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
